<template>
  <div class="opc-success" :class="{ ['opc-success__apm']: isAPM }" role="main" v-loading="loading">
    <apm-bank-transfer v-if="this.apmMethodName === 'customer_balance'" />
    <img v-else class="opc-success__logo" src="@/assets/success/success_bg.png" alt="" />
    <div class="opc-success__content" :class="{ ['opc-success__content-apm']: isAPM }">
      <h1>{{ getSuccessTitle }}</h1>
      <p v-html="getSuccessSubtitle"></p>
      <template v-if="isZPS || ((isBizPlus || isProPlus) && !isEduCoppa)">
        <template v-if="isBizPlus && companySetupZoomOneName">
          <p class="opc-success__setup-msg" v-html="$t('billing.zobizplus.set_up_new_biz_plus_success_msg')"></p>
          <SetUpContent :show-view-account="false" setUpBtnType="primary" :companySetupZoomOneName="companySetupZoomOneName"/>
        </template>
        <template v-else-if="isProPlus">
          <p style="margin: 15px 0; max-width: 540px;" ref="specialListRef" v-html="$t('billing.pbx.pbx_specialist')"></p>
          <template>
            <SetUpContent v-if="companySetupZoomOneName" :show-view-account="false" setUpBtnType="primary" :companySetupZoomOneName="companySetupZoomOneName"/>
            <set-up-zp-cta-group v-else />
          </template>
        </template>
        <template v-else>
          <p style="margin: 15px 0; max-width: 540px;" ref="specialListRef" v-html="$t('billing.pbx.pbx_specialist')"></p>
          <set-up-zp-cta-group />
        </template>
      </template>
      <!-- // BUY TRIAL -->
      <template v-else-if="isBuyTrialFlow">
        <div class="opc-success__content-btn-wrap">
          <zm-button target="_blank" v-if="isZoomSchedulerFreeTrial" round size="large" type="primary" :href="schedulerLink" @click="goFreeTrialTracking" class="text-capitalize buynow-first-btn">
            {{ $t('billing.trial.start_free_trial_btn', [buyTrialPlanName]) }}
          </zm-button>
          <zm-button class="opc-success__content-setup-btn opc-success__content-setup-btn--round text-capitalize" round size="large" type="plain" @click="goBilling">
            {{ this.$t('billing.success.btn') }}
          </zm-button>
        </div>
      </template>
      <template v-else-if="isEduCoppa">
        <p style="margin: 15px 0;max-width: 800px;">{{ $t('billing.success.coppa.tip') }}</p>
        <zm-button type="primary" @click="onEduCoppaProceed">{{ $t('billing.success.coppa.click_to_proceed') }}
        </zm-button>
        <edu-coppa-dialog :visible.sync="isShowEduCoppaDialog" />
      </template>
      <template v-else-if="isVideoSDK">
        <zm-button type="primary"  round size="large" @click="goSDK" class="sdk-btn">{{ $t('billing.success.sdk_btn') }}
        </zm-button>
        <p class="sdk-btns">
          <a href="https://developers.zoom.us/docs/video-sdk/">{{ $t('billing.success.view_doc') }}</a>
          <a href="/billing">{{ $t('billing.success.review_your_subscription') }}</a>
        </p>
      </template>
      <template v-else>
        <template v-if="companySetupZoomOneName">
          <p class="opc-success__setup-msg" v-if="companySetupZoomOneDesc" v-html="companySetupZoomOneDesc"></p>
          <SetUpContent :show-view-account="false" setUpBtnType="primary" :companySetupZoomOneName="companySetupZoomOneName"/>
        </template>
        <template v-else>
          <SetUpContent />
        </template>
      </template>
      <legacy-partner-promote :partner-refer-json-string="partnerReferJsonString"/>
      <div class="opc-success__download-container" v-if="!isVideoSDK">
        <p class="opc-success__download-app"  v-if="!isMobile">{{ $t('billing.success.download_the_zoom_app') }}</p>
        <div class="opc-success__download-platform" v-if="isMac">
          <a v-if="macDownloadUrl"
             class="opc-success__platform-link btn"
             :href="macDownloadUrl"
             :data-on-event="dataOnEvent"
             @click="downloadApp('MAC')"
             aria-label="Download the Zoom App MAC">
            <img class="plat-icon" src="@/assets/success/macos.png" alt="">
            <p class="plat-title">{{ $t('billing.success.download_mac_brief') }}</p>
          </a>
          <a v-if="macDownloadClientUrl"
             class="opc-success__platform-link btn"
             :href="macDownloadClientUrl"
             :data-on-event="dataOnEvent"
             @click="downloadApp('MAC')"
             aria-label="Download the Zoom App MAC">
            <img class="plat-icon" src="@/assets/success/macos.png" alt="">
            <p class="plat-title">{{ $t('billing.success.download_mac_brief') }}</p>
          </a>
          <a class="opc-success__platform-link btn"
             :href="macArm64DownloadUrl"
             :data-on-event="dataOnEvent"
             @click="downloadApp('Macs with Apple Silicon chips')"
             aria-label="Download the Zoom App Macs with Apple Silicon chips">
            <img class="plat-icon" src="@/assets/success/mac-m1.png" alt="">
            <p class="plat-title plat-title-with-span msg-for-m1" v-html="$t('billing.update.download_mac_m1')"></p>
          </a>
        </div>
        <div class="opc-success__download-platform" v-if="isWindows">
          <a v-if="winDownloadClientUrl"
             :href="winDownloadClientUrl"
             :value="winDownloadClientInstallerName"
             class="btn download opc-success__platform-link"
             :data-on-event="dataOnEvent"
             @click="downloadApp('WINDOWS PC')"
             aria-label="Download the Zoom App Windows PC">
            <img class="plat-icon" src="@/assets/success/winpc.png" alt="">
            <p class="plat-title">{{ $t('billing.success.download_windows') }}</p>
          </a>
          <a v-if="winDownloadClientUrlForX64"
             class="btn download opc-success__platform-link"
             :href="winDownloadClientUrlForX64"
             :data-on-event="dataOnEvent"
             @click="downloadApp('Windows 64-bit')"
             aria-label="Download the Zoom App Windows 64-bit">
            <img class="plat-icon" src="@/assets/success/winpc.png" alt="">
            <p class="plat-title plat-title-with-span" v-html="$t('billing.success.download_windows_64')"></p>
          </a>
          <a v-if="winDownloadClientUrlForArm64"
             class="btn download opc-success__platform-link"
             :href="winDownloadClientUrlForArm64"
             :data-on-event="dataOnEvent"
             @click="downloadApp('Windows ARM')"
             aria-label="Download the Zoom App Windows ARM">
            <img class="plat-icon" src="@/assets/success/win-arm.png" alt="">
            <p class="plat-title plat-title-with-span" v-html="$t('billing.success.download_windows_arm')"></p>
          </a>
        </div>
        <div class="opc-success__download-platform" v-if="isMobile">
          <a
          class="btn download opc-success__platform-link"
            target="__blank"
            :href="storeLink"
            :data-on-event="dataOnEvent"
            aria-label="Download App"
          >
            <img class="plat-icon" src="@/assets/plans/icon_ZM.svg" />
            <p>{{ $t('billing.success.download_app',[mobileSys]) }}</p>
          </a>
          <a
            class="btn download opc-success__platform-link"
            href="/schedule"
            :data-on-event="dataOnEvent"
            aria-label="Launch Meeting"
          >
            <img class="plat-icon" src="@/assets/plans/zoom_meeting.svg" />
            <p>{{ $t('billing.success.launch_meeting') }}</p>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/jsx">
import EduCoppaDialog from './edu-coppa-dialog.vue';
import ApmBankTransfer from './apm-bank-transfer.vue'
import QueryString from 'qs';
import { successConfig } from '@/apis/config';
import { dateTimeFormat } from '@/utils/dateformat.js';
import { transferMoney } from "@/utils/money";
import { isEmptyVal, safeJSONParse } from '@/utils';
import { companySetupProductTypeMap, planTypes } from '@/common/constants';
import { includes } from 'lodash';
import { flowTypes } from '@/common/service/page-config';
import { getPlanTypeByCategory } from '@/common/service/parse';
import LegacyPartnerPromote from '@/views/success/legacy-partner-promote.vue';

export const displayPlanNamesMap = {
  [planTypes.ZOOM_SCHEDULER]: 'billing.scheduler.title',
  [planTypes.WEBINAR]: 'billing.webinar.title'
}

export const ZOOM_SCHEDULER_ORIGIN = "/appointment";
export const WEBINAR500_SCHEDULE_LINK = "/webinar/schedule";

const osMap = {
  mac: 'mac',
  win: 'win',
  ios: 'iOS',
  android: 'Android'
};

const SetUpZpCtaGroup = {
  name: 'setUpZpCtaGroup',
  computed: {
    bookWithSpecialistLink(){
      return this.$config('bookWithSpecialistLink');
    },
  },
  methods: {
    toSpecialList() {
      this.$tracking.buyInteraction(`purchase confirmation`, 'book with a specialist');
    },
    toSetupZP() {
      this.$tracking.buyInteraction(`purchase confirmation`, 'set up zoom phone');
    },
  },
  render() {
    return <div class="opc-success__content-btn-wrap" >
      {
        this.bookWithSpecialistLink ? <zm-button
        ref="specialLinkRef"
        target="_blank"
        round
        size="large"
        type="primary"
        href={this.bookWithSpecialistLink}
        class="buynow-first-btn">
        { this.$t('billing.pbx.book_specialist_button') }
        </zm-button> : null
      }
      {
        <zm-button
          ref="setupZPRef"
          class="opc-success__content-setup-btn"
          round
          size="large"
          type="plain"
          href="/pbx/page/telephone/new?p=new">
          { this.$t('billing.success.get_started')}
        </zm-button>
      }
  </div>
  },
  mounted() {
    this.$nextTick(() => {
      if(this.$refs.specialLinkRef) {
        this.$refs.specialLinkRef.$el.removeEventListener('click', this.toSpecialList.bind(this));
        this.$refs.specialLinkRef.$el.addEventListener('click', this.toSpecialList.bind(this));
      }
      if(this.$refs.setupZPRef) {
        this.$refs.setupZPRef.$el.removeEventListener('click', this.toSetupZP.bind(this));
        this.$refs.setupZPRef.$el.addEventListener('click', this.toSetupZP.bind(this));
      }
    });
  },
}

const SetUpContent = {
  name: 'SetUpContent',
  props: {
    companySetupZoomOneName: {
      type: String,
      default: ''
    },
    showViewAccount: {
      type: Boolean,
      default: true
    },
    setUpBtnType: {
      type: String,
      default: 'plain'
    }
  },
  methods: {
    goBilling() {
      this.$tracking.postPurchase('visit my account');
      window.location.href = '/billing';
    },
    goFreeTrialTracking() {
      this.$tracking.postPurchase(this.isZoomSchedulerFreeTrial ? `set up Scheduler`: `start free trial`);
    },
    goCompanySetup() {
      this.$tracking.postPurchase('company setup');
      window.location.href = '/setup-guide';
    },
  },
  render() {
    const content = [];
    if (this.showViewAccount) {
      content.push(<zm-button
        class="opc-success__content-visit-account-btn text-capitalize buynow-first-btn"
        round
        type="primary"
        size="large"
        on-click={this.goBilling}
        id="the-main-content"
      >
        {this.$t('billing.success.btn')}
      </zm-button>)
    }
    if (this.companySetupZoomOneName) {
      content.push(<zm-button
        class="opc-success__content-setup-btn opc-success__content-setup-btn--round"
        type={this.setUpBtnType}
        size="large"
        on-click={this.goCompanySetup}
      >
        {this.companySetupZoomOneName}
      </zm-button>)
    }
    return (<div class="opc-success__content-btn-wrap">
      {content.map(item => item)}
    </div>)
  }
}

export default {
  name: 'successPage',
  components: { LegacyPartnerPromote, EduCoppaDialog, ApmBankTransfer, SetUpContent, SetUpZpCtaGroup },
  created() {
    this.getSuccessPageConfig();
  },
  data() {
    return {
      ariaDescribedby: 'download_client_title',
      dataOnEvent: 'send,event,download,click-zoomclient-button,Download Zoom Client',
      isShowEduCoppaDialog: false,
      partnerReferJsonString: '',
      loading: true,
      purchaseInfo:[],
      schedulerLink: ZOOM_SCHEDULER_ORIGIN
    };
  },
  computed: {
    companySetupProductTypeList() {
      return safeJSONParse(this.$config('eligibleProductTypeJson'), []);
    },
    isJustSetupOneProduct() {
      return (this.companySetupProductTypeList || []).length === 1;
    },
    isBuyTrialFlow() {
      const query = QueryString.parse(location.search.slice(1));
      const { type: successFlowType = '' } = query || {};
      return successFlowType === flowTypes.buyTrial;
    },
    buyTrialPlan() {
      const query = QueryString.parse(location.search.slice(1));
      const { from: successPlanCode = '' } = query || {};
      return getPlanTypeByCategory(successPlanCode) || '';
    },
    isZoomSchedulerFreeTrial() {
      return this.isBuyTrialFlow && this.buyTrialPlan === planTypes.ZOOM_SCHEDULER
    },
    buyTrialPlanName() {
      return this.$t(displayPlanNamesMap[this.buyTrialPlan]) || '';
    },
    companySetupPro() {
      return this.isJustSetupOneProduct && includes(this.companySetupProductTypeList, companySetupProductTypeMap.pro);
    },
    companySetupBiz() {
      return this.isJustSetupOneProduct && includes(this.companySetupProductTypeList, companySetupProductTypeMap.biz);
    },
    companySetupBizPlus() {
      return this.isJustSetupOneProduct && includes(this.companySetupProductTypeList, companySetupProductTypeMap.biz_plus);
    },
    companySetupProPlus() {
      return this.isJustSetupOneProduct && includes(this.companySetupProductTypeList, companySetupProductTypeMap.pro_plus);
    },
    companySetupEduSchCmpPlus() {
      return this.isJustSetupOneProduct && includes(this.companySetupProductTypeList, companySetupProductTypeMap.edu_sch_cmp_plus);
    },
    companySetupAccount() {
      // setup the numbers of product more than one, should show setup account
      return this.companySetupProductTypeList?.length > 1;
    },
    companySetupZoomOneName() {
      if (this.companySetupPro) {
        return this.$t('billing.success.setup_zoom_one_pro');
      } else if (this.companySetupBiz) {
        return this.$t('billing.success.setup_zoom_one_biz');
      } else if (this.companySetupBizPlus) {
        return this.$t('billing.success.setup_zoom_one_biz_plus');
      } else if (this.companySetupProPlus) {
        return this.$t('billing.success.setup_zoom_one_pro_plus');
      } else if (this.companySetupEduSchCmpPlus) {
        return this.$t('billing.success.setup_zoom_one_edu_sch_cmp_plus');
      } else if (this.companySetupAccount) {
        return this.$t('billing.success.setup_zoom_account');
      }

      return '';
    },
    companySetupZoomOneDesc() {
      if (this.companySetupPro) {
        return this.$t('billing.zoom_one_pro.set_up_success_msg');
      } else if (this.companySetupBiz) {
        return this.$t('billing.zoom_one_biz.set_up_success_msg');
      } else if (this.companySetupBizPlus) {
        return this.$t('billing.zobizplus.set_up_new_biz_plus_success_msg');
      }

      return '';
    },
    isAPM() {
      return !isEmptyVal(this.apmMethodName)
    },
    getSuccessTitle() {
      if (this.isAPM) {
        return this.$t('billing.success.subscription_activated')
      }
      if (this.isVideoSDK) {
        return this.$t('billing.success.sdk_title')
      }
      return this.$t('billing.success.title')
    },
    getSuccessSubtitle() {
      if (this.isAPM) {
        if (this.apmMethodName === "customer_balance") {
          return this.$t('billing.bank_transfer.message', [5, this.email])
        }
        return this.$t('billing.success.process_payment_once_verified', [this.email])
      }
      if(this.isVideoSDK && this.purchaseInfo){
        const { planStartTime, planExpireTime, totalAmount }  = this.purchaseInfo
        return `<p class="sdk-para">${this.$t('billing.success.sdk_para_1',[
          dateTimeFormat(planStartTime),
          transferMoney(totalAmount),
          dateTimeFormat(planExpireTime)
        ])}</p><br /><p class="sdk-para">${this.$t('billing.success.sdk_para_2')}</p>`
      }
      // BUY TRIAL
      if(this.isBuyTrialFlow && this.buyTrialPlanName) {
        return `<p class="trial-desc">${this.$t('billing.trial.buy_trial_success', [this.buyTrialPlanName])}</p><br /><p class="trial-desc">${this.$t('billing.success.subtitle')}</p>`
      }

      return this.$t('billing.success.subtitle')
    },
    email() {
      return this.$config('email')
    },
    apmMethodName() {
      return this.$config('apmMethodName')
    },
    isMac() {
      return this.$config('os') === osMap.mac;
    },
    isWindows() {
      return this.$config('os') === osMap.win;
    },
    macDownloadUrl() {
      return this.$config('macDownloadUrl');
    },
    macDownloadClientUrl() {
      return this.$config('macDownloadClientUrl');
    },
    macArm64DownloadUrl() {
      return this.$config('macArm64DownloadUrl');
    },
    winDownloadClientUrl() {
      return this.$config('winDownloadClientUrl');
    },
    winDownloadClientInstallerName() {
      return this.$config('winDownloadClientInstallerName');
    },
    winDownloadClientUrlForX64() {
      return this.$config('winDownloadClientUrlForX64');
    },
    winDownloadClientUrlForArm64() {
      return this.$config('winDownloadClientUrlForArm64');
    },
    isEduCoppa() {
      return this.$config('isEduCoppa');
    },
    isZPS() {
      const query = QueryString.parse(location.search.slice(1));
      return query.plan === 'pbx';
    },
    isBizPlus() {
      const query = QueryString.parse(location.search.slice(1));
      return query.plan === 'zonebundle' || query.type === flowTypes.biz2bundle || query.type === flowTypes.prop2bundle;
    },
    isProPlus() {
      const query = QueryString.parse(location.search.slice(1));
      return query.plan === planTypes.ZONE_PRO_PLUS || query.type === flowTypes.pro2prop;
    },
    isVideoSDK() {
      const query = QueryString.parse(location.search.slice(1));
      const videoSDKList = ['litesdk','zsdkuc']
      return !!videoSDKList.includes(query.plan);
    },
    isAndroid(){
      const u = navigator.userAgent || '';
      return  u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
    },
    isIOS(){
      return /(iPad|iPhone|iPod)/g.test(navigator.userAgent || '');
    },
    storeLink(){
      return this.isAndroid
        ? 'https://play.google.com/store/apps/details?id=us.zoom.videomeetings'
        : 'https://itunes.apple.com/us/app/id546505307';
    },
    isMobile() {
      return this.isAndroid || this.isIOS
    },
    mobileSys(){
      return this.isAndroid? osMap.android : osMap.ios
    },
    bookWithSpecialistLink(){
      return this.$config('bookWithSpecialistLink');
    },
  },
  methods: {
    goBilling() {
      this.$tracking.postPurchase('visit my account');
      window.location.href = '/billing';
    },
    onEduCoppaProceed() {
      this.isShowEduCoppaDialog = true;
    },
    goSDK() {
      this.$tracking.buyInteraction(`purchase confirmation`, 'start building your app');
      window.location.href = 'https://marketplace.zoom.us/develop/create'
    },
    downloadApp(appName) {
      this.$tracking.postPurchase(`download zoom app - ${appName}`);
    },
    trackingBilling(e) {
      if(e.target?.href) {
        this.$tracking.buyInteraction('purchase confirmation', `review your plan - click here`);
      }
    },
    async getSuccessPageConfig() {
      try {
        const { result } = await successConfig({coppa: window.newBillingConfig?.coppa});
        this.partnerReferJsonString = result?.partnerRefer;
        this.purchaseInfo = result?.purchaseInfo;
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    if (this.isZPS || this.isProPlus) {
      this.$nextTick(() => {
        if(this.$refs.specialListRef) {
          this.$refs.specialListRef.removeEventListener('click', this.trackingBilling.bind(this));
          this.$refs.specialListRef.addEventListener('click', this.trackingBilling.bind(this));
        }
      })
    }
  }
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';

#content_container {
  min-height: auto;
}

.opc-success {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 100px 50px;
  @include media(mobile,tablet){
    flex-direction: column;
    padding: 10px;
  }

  &__apm {
    align-items: flex-start;
  }

  &__logo {
    width: 563px;
    height: 449px;
    @include media(mobile,tablet){
      width: 314px;
      height: 250px;
    }
  }

  &__content {
    margin-left: 80px;
    color: #222230;
    max-width: 700px;
    @include media(mobile,tablet){
      margin: 10px 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    h1 {
      &::first-letter {
        text-transform: capitalize;
      }

      font-family: $happy-display;
      font-style: normal;
      font-weight: 400;
      margin-bottom: 12px;
      font-size: 24px;
      @include media(mobile,tablet){
        text-align: center;
        line-height: 30px;
        font-size: 20px;
      }
    }

    p {
      &::first-letter {
        text-transform: capitalize;
      }

      font-size: 16px;

      @include media(mobile,tablet){
        font-size: 14px;
        text-align: center;
        white-space: normal;
      }

    }

    &-btn-wrap {
      padding: 32px 0px 22px;

      @include media(mobile,tablet){
        width: 90%;
        margin: auto;
        .zm-button{
          width: 100%;
        }
      }

    }

    .sdk-btn{
      margin: 30px 0;
    }

    .sdk-para{
      &:first-child{
        margin-top: 20px;
      }
      margin-top: 5px;
    }

    .sdk-btns{
      a{
        margin-right: 10px;
        border-right: 1px;
        &:first-child::after {
          content: '|';
          color: #0e72ed;
          font-weight: 900;
          position: relative;
          top: -1px;
          margin-left: 10px;
          padding: 2px 4px;
          border-radius: 4px;
        }
      }
    }

    &-setup-btn {
      min-width: 240px;

      &.zm-button--large.is-round {
        font-size: 16px;
        color: #0B5CFF;
        border-color: #0B5CFF;
        line-height: 24px;
        padding: 9px 16px;
        margin-left: 0;
      }

      &--round {
        &.zm-button--large, .zm-button--middle {
          border-radius: 20px;
          padding: 9px 16px;
        }
      }
    }

    .buynow-first-btn{
      margin-right: 10px;
      @include media(mobile,tablet){
        margin-bottom: 10px;
    }
    }

    &-visit-account-btn {
      background: #0B5CFF !important;
    }
  }

  &__setup-msg {
    margin: 15px 0 0;
    max-width: 540px;
  }

  &__content-apm {
    max-width: 575px;

    h1 {
      font-family: $happy-display;
      font-size: 24px;
      font-weight: 500;
      margin-bottom: 24px;
    }

    p {
      max-width: 575px;

      .apm-furikomi-success {
        font-weight: 700;
        margin-bottom: 24px;
      }
    }
  }

  &__download-container {
    margin: 20px 0;
  }

  &__download-app {
    font-size: 16px;
  }

  &__download-platform {
    margin: 16px 0;
    display: flex;
  }

  &__platform-link {
    width: 171px;
    height: 160px;
    margin-right: 15px;
    color: #333;
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid #dadada;
    border-radius: 12px;
    text-align: center;
    cursor: pointer;
    padding: 5px 16px;
    white-space: nowrap;
    vertical-align: middle;
    margin-bottom: 0;
    font-size: 14px;
    font-weight: normal;
    line-height: 1.42857143;
    user-select: none;
    background-image: none;

    @include media(mobile,tablet){
        &:last-child{
          margin-right: 0;
        }
    }

    &:hover {
      transition: all .5s;
      box-shadow: 0px 40px 60px rgba(0, 0, 0, 0.1);
      border: 0;
      color: #333;
      text-decoration: none;
    }

    .plat-icon {
      width: 53px;
      height: 53px;
      margin: 40px 0 0px;
      @include media(mobile,tablet){
        margin-bottom: 10px;
      }

    }

    .plat-title {
      margin-top: 8px;
      font-size: 12px;
    }

    .plat-title-with-span {
      margin-top: 4px;
    }

    .plat-title span {
      font-size: 10px;
    }

    .msg-for-m1 span {
      font-size: 10px;
    }
  }

  &__partner {
    display: flex;
    align-items: center;
    padding: 22px 26px 23px 23px;
    background: #FFFFFF;
    border: 1px solid #B6B6C2;
    border-radius: 12px;
    margin-top: 25px;
    margin-bottom: 45px;
    width: 600px;

    &--icon {
      background: linear-gradient(96.59deg, #084845 10.36%, #09A639 89.64%);
      font-family: 'SF Pro', 'Almaden Sans';
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      padding: 0px 4px;
      color: #ffffff;
      border-radius: 100px;
      white-space: nowrap;
      height: 16px;
      margin-right: 6px;
    }
    &--content {
      font-weight: 450;
      font-size: 16px;
      line-height: 150%;
      color: #222230;
    }
  }
}
</style>
